module.exports = __webpack_public_path__ + "static/media/November_2026_1.6fae17f0.webp";